import React from 'react';
import ReactToPrint from 'react-to-print';

import {
  Button,
  Row, Col,
} from 'reactstrap';

import FontAwesome from 'react-fontawesome';
import TMCLogoColorRGB from 'img/TMCLogoColorRGB.png';
import TMC_033_Editable_Golf_Club_Flyer_Golfer from 'pdf/TMC_033_Editable_Golf_Club_Flyer_Golfer.pdf';

import download from 'downloadjs';
import { PDFDocument } from 'pdf-lib';

import { Bootstrap2Toggle } from 'react-bootstrap-toggle';
import "utils/bootstrap2-toggle.css";

import {
  MobileHeader,
  ContentWrapper
} from 'common/CommissionerComponents.js';

import {
  get_club_promo_data, get_club_flyer_pdf, get_club_flyer_doc,
} from 'utils/api.js';

export default class ClubPromotion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfData:null,
      promoData: null,
      mcTemplate: true,
    };
    this.printRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.fetchClubPdfView = this.fetchClubPdfView.bind(this);
    this.fetchClubPromoData = this.fetchClubPromoData.bind(this);
    this.fetchClubDocView = this.fetchClubDocView.bind(this);
    this.exportHTMLToDoc = this.exportHTMLToDoc.bind(this);
    this.downloadClubQRCode = this.downloadClubQRCode.bind(this);
    this.downloadPDF = this.downloadPDF.bind(this);
    this.printPDF = this.printPDF.bind(this);
    this.createPDF = this.createPDF.bind(this);
    this.toggleMCTemplate = this.toggleMCTemplate.bind(this);
  }

  toggleMCTemplate(state){
    this.setState({ mcTemplate:state });
  }

  async createPDF(){
    //const formUrl = 'https://media.majorschallenge.com/TMC_033_Editable_Golf_Club_Flyer_Golfer.pdf';
    const formPdfBytes = await fetch(TMC_033_Editable_Golf_Club_Flyer_Golfer).then(res => res.arrayBuffer());

    // Fetch the Mario image
    const qrUrl = "data:image/png;base64," + this.state.promoData.clubUrlQrCode;
    const qrImageBytes = await fetch(qrUrl).then(res => res.arrayBuffer());

    // Load a PDF with form fields
    const pdfDoc = await PDFDocument.load(formPdfBytes)

    const qrImage = await pdfDoc.embedPng(qrImageBytes);

    // Get the form containing all the fields
    const form = pdfDoc.getForm();
    /*const fields = form.getFields()
    fields.forEach(field => {
      const type = field.constructor.name
      const name = field.getName()
      console.log(`${type}: ${name}`)
    })*/

    // Get all fields in the PDF by their names
    const clubName = form.getTextField('Country Club Name');
    clubName.setText(this.state.promoData.clubName.toUpperCase());
    clubName.enableReadOnly();

    const callToAction = form.getTextField('Golf Pool');
    callToAction.setText(this.state.promoData.callToAction.toUpperCase());
    callToAction.enableReadOnly();

    const tournament = form.getTextField('Tournament Name');
    tournament.setText(this.state.promoData.tournament.toUpperCase());
    tournament.enableReadOnly();

    const entryFee = form.getTextField('Entry Fee');
    entryFee.setText('ENTRY: ' + this.state.promoData.entryFee.toUpperCase());
    entryFee.enableReadOnly();

    const prize = form.getTextField('Prize');
    prize.setText(this.state.promoData.prizes.toUpperCase());
    prize.enableReadOnly();

    const clubURL = form.getTextField('URL');
    clubURL.setText(this.state.promoData.clubURL);
    clubURL.enableReadOnly();

    const qrCode = form.getButton('QR Code');
    qrCode.setImage(qrImage);
    qrCode.enableReadOnly();

    // Serialize the PDFDocument to bytes (a Uint8Array)
    const pdfBytes = await pdfDoc.save();
    return pdfBytes;
  }

  async printPDF(){
    const pdfBytes = await this.createPDF();
    var blob = new Blob([pdfBytes], {type: "application/pdf"});
    var blob_url = URL.createObjectURL(blob);
    var pdfContainer = document.querySelector('#pdfContainer');
    pdfContainer.src = blob_url;
    pdfContainer.onload = function() { this.contentWindow.print(); };
  }

  async downloadPDF(){
    const pdfBytes = await this.createPDF();
    download(pdfBytes, this.state.promoData.clubName.toUpperCase() + ".pdf", "application/pdf");
  }

  exportHTMLToDoc(){

    const allCSS = [...document.styleSheets]
      .map(styleSheet => {
        try {
          return [...styleSheet.cssRules]
            .map(rule => rule.cssText)
            .join('');
        } catch (e) {
          console.log('Access to stylesheet %s is denied. Ignoring...', styleSheet.href);
        }
      })
      .filter(Boolean)
      .join('\n');

      /*
       const header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
            "xmlns:w='urn:schemas-microsoft-com:office:word' "+
            "xmlns='http://www.w3.org/TR/REC-html40'>"+
            "<head><meta charset='utf-8'><title>Doc</title>" +
            "<base href='http://localhost:3030' target='_blank'>" +
            "</head>";

       const footer = "</html>";
       const sourceHTML = header+"<style>" + allCSS + "</style><body>" +
       document.getElementById("docHTML").outerHTML+"</body>" + footer;

       /*var sourceHTML = header+"<style>" + allCSS + "</style><body>" +
       '<div class="p-3 mb-4 text-center text-bold" style="margin-top:80px"}}>' +
       document.getElementById("source-html").innerHTML+"</div></body>" + footer;
       console.log('html :: '+ document.getElementById("source-html").innerHTML);
       console.log(sourceHTML);
       const source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
       const fileDownload = document.createElement("a");
       document.body.appendChild(fileDownload);
       fileDownload.href = source;
       fileDownload.download = 'document.doc';
       fileDownload.click();
       document.body.removeChild(fileDownload);*/

       var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>"+
       "<head><meta charset='utf-8'><title>Export HTML To Doc</title>" +
       "<style>" + allCSS + "</style>" +
       "</head><body>";
      var postHtml = "</body></html>";
      var html = preHtml+document.getElementById("docHTML").outerHTML+postHtml;

      var blob = new Blob(['\ufeff', html], {
          type: 'application/msword'
      });

      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

      // Specify file name
      var filename = 'document.doc';

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if(navigator.msSaveOrOpenBlob ){
          navigator.msSaveOrOpenBlob(blob, filename);
      }else{
          // Create a link to the file
          downloadLink.href = url;

          // Setting the file name
          downloadLink.download = filename;

          //triggering the function
          downloadLink.click();
      }

      document.body.removeChild(downloadLink);
  }

  componentDidMount() {
    this.fetchClubPromoData(this.props.activeLeague);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.activeLeague === nextProps.activeLeague) {
      return
    }
    this.fetchClubPromoData(nextProps.activeLeague);
  }

  handleChange(event) {
    let promoData = this.state.promoData;
    promoData[event.target.name] = event.target.value;
    this.setState({promoData: promoData});
  }

  fetchClubPromoData(league){
    var hostUrl = window.location.origin;
    get_club_promo_data(league,hostUrl,
    ({sucess, error, promoData}) => {
        console.log(promoData);

        const toDataURL = url => fetch(url)
                              .then(response => response.blob())
                              .then(blob => new Promise((resolve, reject) => {
                                const reader = new FileReader()
                                reader.onloadend = () => resolve(reader.result)
                                reader.onerror = reject
                                reader.readAsDataURL(blob)
                              }));
        toDataURL(TMCLogoColorRGB)
                        .then(dataUrl => {
                          console.log('RESULT:', dataUrl);
                          this.setState({logoBase64:dataUrl});
                        })
        this.setState({promoData});
    }, (error) => {
      console.log(error);
    });
  }

  downloadClubQRCode(){
    var a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + this.state.promoData.clubUrlQrCode; //Image Base64 Goes here
    a.download = this.state.promoData.clubName + " QR.png"; //File name Here
    a.click(); //Downloaded file
  }

  fetchClubPdfView(){
    const league = this.props.activeLeague;
    const hostUrl = window.location.origin;
    let logoBase64 ='';
    get_club_flyer_pdf(league, this.state.promoData.clubName,
      this.state.promoData.callToAction,
      this.state.promoData.tournament,
      this.state.promoData.entryFee,
      this.state.promoData.prizes, this.state.logoBase64, hostUrl,
    ({data}) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.promoData.clubName + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, (error) => {
      console.log(error);
    });

  }

  fetchClubDocView(){
    const league = this.props.activeLeague;
    const hostUrl = window.location.origin;
    let logoBase64 ='';
    get_club_flyer_doc(league, this.state.promoData.clubName,
      this.state.promoData.callToAction,
      this.state.promoData.tournament,
      this.state.promoData.entryFee,
      this.state.promoData.prizes, this.state.logoBase64, hostUrl,
    ({data}) => {

      var blob = new Blob(['\ufeff', data], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      });

      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(data);

      // Specify file name
      var filename = 'document.docx';

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if(navigator.msSaveOrOpenBlob ){
          navigator.msSaveOrOpenBlob(blob, filename);
      }else{
          // Create a link to the file
          downloadLink.href = url;

          // Setting the file name
          downloadLink.download = filename;

          //triggering the function
          downloadLink.click();
      }

      document.body.removeChild(downloadLink);

         url = window.URL.createObjectURL(new Blob([data], {type:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"}));
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'club.docx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, (error) => {
      console.log(error);
    });

  }

  render() {

    const pageStyle = `
      @page {
        size: A4;
        margin: 20mm;
      }

      @media print {
        @page {
          size: A4;
        }
      }
    `;

    return (
      <div className="">
        <MobileHeader to="Promotion" leagueid={this.props.activeLeague} />
        <div>
          <div className="mb-1 ml-3" style={{fontSize: "1.75em", fontWeight: 300}}>
            {'Promotion'}
          </div>
          <ClubPromoCard promoData = {this.state.promoData} handleChange={this.handleChange} mcTemplate={this.state.mcTemplate}
            toggleMCTemplate={this.toggleMCTemplate}/>


          <div style={{ display: "none" }}><ClubPromoCardPrint promoData = {this.state.promoData} ref={el => (this.componentRef = el)}/></div>
          <div style={{ display: "none" }}><ClubPromoCardDocPrint promoData = {this.state.promoData} logoBase64={this.state.logoBase64}/></div>

          <Row  noGutters className="text-left pl-3 pb-3 pb-sm-0 d-flex">
            <Col sm="12" md="9" className="">

              {!this.state.mcTemplate &&
                <>
                <ReactToPrint trigger={() => {
                    return  <Button color="primary" size="sm" className="ml-3 mb-3" outline><FontAwesome name="print" /> Preview PDF</Button>;
                  }}
                  content={() => this.componentRef}
                  documentTitle = "Pro Shop / Locker Room Flyer"
                  pageStyle="@page { size: letter;  margin: 0mm; }"
                />
                <Button color="primary" size="sm" className="ml-3 mb-3" outline onClick={() => this.fetchClubPdfView()}>
                    <FontAwesome name="download" /> Download PDF
                </Button>
                </>
              }
              {this.state.mcTemplate &&
                <>
                <Button color="primary" size="sm" className="ml-3 mb-3" outline onClick={() => this.printPDF()}>
                      <FontAwesome name="print" /> Preview PDF
                </Button>
                <Button color="primary" size="sm" className="ml-3 mb-3" outline onClick={() => this.downloadPDF()}>
                    <FontAwesome name="download" /> Download PDF
                </Button>
                </>
              }

              <Button color="primary" size="sm" className="ml-3 d-none mb-3" outline onClick={() => this.fetchClubDocView()}>
                  <FontAwesome name="download" /> Edit DOC
              </Button>

              <Button color="primary" size="sm" className="ml-3 mb-3" outline onClick={() => this.downloadClubQRCode()}>
                  <FontAwesome name="download" /> Download QR
              </Button>

            </Col>
          </Row>

          <iframe title="pdfContainer" id="pdfContainer"width="297mm" height="210mm" className="d-none" />

        </div>
      </div>
    )
  }
}

class ClubPromoCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }
  }

  render() {
    if (!this.props.promoData){
      return <Row className="text-center pb-3 pb-sm-0">
        <Col sm="12" md="9" className="">
          <FontAwesome name="spinner" className="" size="3x" spin />
        </Col>
      </Row>;
    }
    const clubUrlQrCode = (this.props.promoData ?'data:image/gif;base64,' + this.props.promoData.clubUrlQrCode:'');
    return (
      <div className="p-3 mb-2">
        <div className="mt-2 mb-1">
          {'Pro Shop / Locker Room Flyer'}
        </div>
        <div className="mb-4" style={{color: "#999", padding: "0"}}>
          {'Promote your golf pool by creating a custom flyer to distribute to your members or post on a wall.'}
        </div>

        <Row className="profileFormRow pb-3 pb-sm-0">
          <Col sm="4" md="3" className="profileFormRow_label">
            Club Name:
          </Col>
          <Col sm="8" md="6" className="profileFormRow_content">
            <input type="text" name="clubName" value={this.props.promoData.clubName} onChange={this.props.handleChange} className="profileFormRow_input form-control"/>
          </Col>
        </Row>
        <Row className="profileFormRow pb-3 pb-sm-0">
          <Col sm="4" md="3" className="profileFormRow_label">
            Call To Action:
          </Col>
          <Col sm="8" md="6" className="profileFormRow_content">
            <input type="text" name="callToAction" value={this.props.promoData.callToAction} onChange={this.props.handleChange} className="profileFormRow_input form-control"/>
          </Col>
        </Row>
        <Row className="profileFormRow pb-3 pb-sm-0">
          <Col sm="4" md="3" className="profileFormRow_label">
            Tournament:
          </Col>
          <Col sm="8" md="6" className="profileFormRow_content">
            <input type="text" name="tournament" value={this.props.promoData.tournament} onChange={this.props.handleChange} className="profileFormRow_input form-control"/>
          </Col>
        </Row>
        <Row className="profileFormRow pb-3 pb-sm-0">
          <Col sm="4" md="3" className="profileFormRow_label">
            Entry Fee:
          </Col>
          <Col sm="8" md="6" className="profileFormRow_content">
            <input type="text" name="entryFee" value={this.props.promoData.entryFee} onChange={this.props.handleChange} className="profileFormRow_input form-control"/>
          </Col>
        </Row>
        <Row className="profileFormRow pb-3 pb-sm-0">
          <Col sm="4" md="3" className="profileFormRow_label">
            Prizes:
          </Col>
          <Col sm="8" md="6" className="profileFormRow_content">
            <input type="text" name="prizes" value={this.props.promoData.prizes} onChange={this.props.handleChange} className="profileFormRow_input form-control"/>
          </Col>
        </Row>
        <Row className="profileFormRow pb-3 pb-sm-0">
          <Col sm="4" md="3" className="profileFormRow_label">
            QR Code:
          </Col>
          <Col sm="8" md="6" className="profileFormRow_content">
            <img src={clubUrlQrCode} width="100px" id="clubURLQRCode" alt="clubUrlQrCode"/>
          </Col>
        </Row>
        <Row className="profileFormRow pb-3 pb-sm-0">
          <Col sm="4" md="3" className="profileFormRow_label">
            Background:
          </Col>
          <Col sm="8" md="6" className="">
              <Bootstrap2Toggle
                onClick={(state)=>{this.props.toggleMCTemplate(state)}}
                on=<span className="text-nowrap">Majors Challenge</span>
                off={'Blank'}
                size="sm"
                offstyle="secondary"
                onstyle="success"
                active={this.props.mcTemplate}
              />
          </Col>
        </Row>


        </div>
    );
  }

}

class ClubPromoCardPrint extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    if (!this.props.promoData){
      return '';
    }
    const clubUrlQrCode = (this.props.promoData ?'data:image/gif;base64,' + this.props.promoData.clubUrlQrCode:'');
    return (
      <>
      <div className="p-3 mb-4 text-center text-bold" style={{marginTop:'80px'}}>
        <div className="my-2 display-4" style={{fontWeight:'500'}}>
          {this.props.promoData.clubName}
        </div>
        <div className="my-2 display-1" style={{fontWeight:'500'}}>
          {this.props.promoData.callToAction}
        </div>
        <div className="mt-2 mb-4 display-4" style={{fontWeight:'500'}}>
          {this.props.promoData.tournament}
        </div>
        <div className="display-2" style={{marginTop:'100px', fontWeight:'500'}}>
          Entry {this.props.promoData.entryFee}
        </div>
        <div className="my-2 display-4" style={{fontWeight:'500'}}>
          {this.props.promoData.prizes}
        </div>
        <div className="my-2">
          <img src={clubUrlQrCode} width="300px" alt="clubUrlQrCode"/>
        </div>
        <div className="my-2" style={{fontWeight:'800', fontSize:'25px'}}>
          {this.props.promoData.clubURL}
        </div>
        <div className="text-center" style={{position:'absolute',bottom:'20px', left:'37%', textAlign:'center'}}>
          <img src={TMCLogoColorRGB} style={{height: "52px"}} alt="TMCLogoColorRGB"/>
        </div>
      </div>
      </>
    );
  }

}


class ClubPromoCardDocPrint extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    if (!this.props.promoData){
      return '';
    }

    let logoBase64 = "data:image/gif;base64,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";

    //logoBase64 = "data:image/gif;base64,"+ encodeURIComponent(window.location.origin + TMCLogoColorRGB);
    const clubUrlQrCode = (this.props.promoData ?'data:image/gif;base64,' + this.props.promoData.clubUrlQrCode:'');
    return (
      <div className="p-3 mb-4 text-center text-bold" style={{marginTop:'80px'}} id="docHTML">
        <div className="my-2 display-4" style={{fontWeight:'500'}}>
          {this.props.promoData.clubName}
        </div>
        <div className="my-2 display-1" style={{fontWeight:'500'}}>
          {this.props.promoData.callToAction}
        </div>
        <div className="mt-2 mb-4 display-4" style={{fontWeight:'500'}}>
          {this.props.promoData.tournament}
        </div>
        <br/><br/><br/><br/>
        <div className="display-2" style={{marginTop:'100px', fontWeight:'500'}}>
          Entry {this.props.promoData.entryFee}
        </div>
        <div className="my-2 display-4" style={{fontWeight:'500'}}>
          {this.props.promoData.prizes}
        </div>
        <div className="my-2">
          <img src={clubUrlQrCode} width="30px" alt="clubUrlQrCode"/>
        </div>
        <div className="my-2" style={{fontWeight:'800', fontSize:'25px'}}>
          {this.props.promoData.clubURL}
        </div><br/><br/><br/><br/>
        <div className="footer" style={{position:'absolute',bottom:'20px', fontSize:'5px', height:'10px'}}>
          <img src={logoBase64} width="5px" style={{fontSize:'5px'}} alt="logoBase64"/>
        </div>
      </div>
    );
  }

}
